document.addEventListener(
  "AppstleSubscription:SubscriptionWidget:SellingPlanSelected",
  function () {
    handleVariantOrSellingPlanChange();
  }
);
document.addEventListener(
  "AppstleSubscription:SubscriptionWidget:SellingPlanRemoved",
  function () {
    handleVariantOrSellingPlanChange();
  }
);

// document.addEventListener(
//   "AppstleSubscription:SubscriptionWidget:widgetInitialised",
//   function () {
//     handleVariantOrSellingPlanChange();
//   }
// );

function updateInputLabels(sourceVariantSelects) {
  const sectionId = document.querySelector("product-info").dataset.section;
  const destinationVariantSelects = document.querySelector(
    `product-info variant-selects[data-section="${sectionId}"]`
  );

  destinationVariantSelects.querySelectorAll("label").forEach((label) => {
    const forAttribute = label.getAttribute("for");
    console.log(label);
    const sourceLabel = sourceVariantSelects.querySelector(
      `label[for="${forAttribute}"]`
    );
    console.log(sourceLabel);
    if (sourceLabel) {
      label.innerHTML = sourceLabel.innerHTML;
    }
  });
}

const CACHE = {};

function handleVariantOrSellingPlanChange(e) {
  setTimeout(function () {
    if (!document.querySelector("product-info")) return;

    const sectionId = document.querySelector("product-info").dataset.section;

    if (CACHE[window.location.href]) {
      updateInputLabels(CACHE[window.location.href]);
      return;
    }

    fetch(`${window.location.href}&section_id=${sectionId}`)
      .then((res) => res.text())
      .then((data) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(data, "text/html");
        const sourceVariantSelects = doc.querySelector(
          "product-info variant-selects"
        );
        updateInputLabels(sourceVariantSelects);
        CACHE[window.location.href] = sourceVariantSelects;
      });
  }, 0);

  document.removeEventListener(
    "AppstleSubscription:SubscriptionWidget:SellingPlanSelected",
    function () {
      handleVariantOrSellingPlanChange();
    }
  );
  document.removeEventListener(
    "AppstleSubscription:SubscriptionWidget:SellingPlanRemoved",
    function () {
      handleVariantOrSellingPlanChange();
    }
  );
}
